import React from 'react';
import Seperator from '../../../../seperator';
export default function CardBottomLowestValidThruLeft() {
  return /*#__PURE__*/React.createElement("div", {
    className: "valid-thru-left"
  }, /*#__PURE__*/React.createElement(Seperator, {
    classes: "block-label",
    seperator: false
  }, "valid"), /*#__PURE__*/React.createElement(Seperator, {
    classes: "block-label",
    seperator: false
  }, "thru"));
}